import script from "./OperationOfficeList.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationOfficeList.vue?vue&type=script&setup=true&lang=js"

import "./OperationOfficeList.vue?vue&type=style&index=0&id=70d3ba5b&lang=css"
import "./OperationOfficeList.vue?vue&type=style&index=1&id=70d3ba5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d3ba5b"]])

export default __exports__